// extracted by mini-css-extract-plugin
export default {"button":"MuteButton_button__s90Wd"};